module.exports = __webpack_public_path__ + "static/img/icon1.9dc8b5cf.svg";